module.exports = require("request");


//////////////////
// WEBPACK FOOTER
// external "request"
// module id = 16
// module chunks = 0